import { render, staticRenderFns } from "./WizardPriceBase.vue?vue&type=template&id=3845f75b&scoped=true&"
import script from "./WizardPriceBase.vue?vue&type=script&lang=js&"
export * from "./WizardPriceBase.vue?vue&type=script&lang=js&"
import style0 from "./WizardPriceBase.vue?vue&type=style&index=0&id=3845f75b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845f75b",
  null
  
)

export default component.exports